/** Opening a node from the inspector: select it and centre the graph on it. */
import { useApp } from "../../app/context";

/** Returns a function that opens a node by id. Call inside a component. */
export function useOpenNode(): (id: string) => void {
  const { view } = useApp();
  return (id: string) => {
    view.selectNode(id);
    view.requestCenter(id);
  };
}
